// 搜索适配参数
const searchForm = {
  data() {
    return {
      searchItemLayout: {
        labelCol: {
          xxl: { span: 6 },
          xl: { span: 6 },
          lg: { span: 7 },
          sm: { span: 6 },
          md: { span: 8 },
          xs: { span: 12 }
        },
        wrapperCol: {
          xxl: { span: 18 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 18 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 17 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 16 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 12 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 12 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      }
    }
  },
  methods: {}
}
export default searchForm
